import React, { useState, useEffect } from "react";
import { Icon } from "@chakra-ui/react";
import { BiDetail } from "react-icons/bi";
import { FiTrash2 } from "react-icons/fi";
import ResponsiveRow from "../Common/Table/ResponsiveRow";
import TdType from "../Common/Table/TdType";
import { useHistory } from "react-router-dom";
import moment from "moment";
import DeleteSupplier from "./DeleteSupplier";
import { currencyFormatter } from "../../Utils/formatUtils";

const SupplierItem = ({ supplier, initialAction = "row", deleteSupplier }) => {
  const [action, setAction] = useState(initialAction);
  const [newSupplier, setNewSupplier] = useState(supplier);
  const [isDeleteSupplierOpen, setIsDeleteSupplierOpen] = useState(false);
  const history = useHistory();
  moment.locale();

  useEffect(() => {
    setNewSupplier(supplier);
  }, [action]);

  const rowDisplay = () => {
    let rowData = [];
    // eslint-disable-next-line default-case
    switch (action) {
      case "row":
        rowData = [
          {
            item: <TdType text={supplier.businessName} />,
          },
          {
            item: <TdType text={supplier.address} />,
          },
          {
            item: <TdType text={supplier.cuit} />,
          },
          {
            item: <TdType text={supplier.phone} />,
          },
          {
            item: (
              <TdType
                customStyle={{
                  textAlign: "right",
                  color: supplier.balance < 0 && "red",
                }}
                text={currencyFormatter(supplier.balance)}
              />
            ),
          },
          {
            tdStyle: {
              textAlign: "center",
              fontSize: "1.3em",
            },
            item: (
              <>
                <Icon
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  as={BiDetail}
                  title={"Mas info"}
                  onClick={() => history.push(`/proveedores/${supplier.id}`)}
                ></Icon>
                <Icon
                  as={FiTrash2}
                  _hover={{ cursor: "pointer" }}
                  mx="2"
                  title="Eliminar"
                  onClick={() => setIsDeleteSupplierOpen(true)}
                />
              </>
            ),
          },
        ];
        return (
          <ResponsiveRow key={supplier.id} cells={rowData}></ResponsiveRow>
        );
    }
  };

  return (
    <>
      {rowDisplay()}
      <DeleteSupplier
        isOpen={isDeleteSupplierOpen}
        setIsOpen={setIsDeleteSupplierOpen}
        supplier={newSupplier}
        action={deleteSupplier}
      ></DeleteSupplier>
    </>
  );
};

export default SupplierItem;
